import RouteConstants from '@/features/router/RouteConstants';
import { useWorkspace } from '@/features/workspaces/hooks';
import { Button } from '@/lib';
import { useGetCampaignsCountQuery } from '@/services/endpoints/campaigns/endpoints';
import BellIcon from '@assets/icons/bell-icon.svg?react';
import { t } from 'i18next';
import { FC, useEffect, useReducer } from 'react';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { CloseAlertButton } from './CloseAlertButton';

export const HomePageAlert: FC = () => {
  const { id } = useWorkspace();
  const { data } = useGetCampaignsCountQuery({
    workspaceId: id,
    status: 'DRAFT',
  });

  const [isOpen, toggleVisibility] = useReducer((state) => !state, false);

  useEffect(() => {
    if (data && data > 0) {
      toggleVisibility;
    }
  }, [data]);

  return (
    <section
      data-open={isOpen}
      className={twMerge(
        'flex justify-between rounded-lg bg-brand-200 px-4 py-2.5 mt-2 overflow-hidden',
        'starting:h-0 starting:py-0 starting:opacity-0 starting:mt-0',
        'data-[open=false]:hidden data-[open=false]:opacity-0 data-[open=false]:h-0 data-[open=false]:py-0 data-[open=false]:mt-0',
        'motion-safe:transition-[display,height,margin,padding,opacity] motion-safe:duration-500 motion-reduce:transition-none transition-discrete'
      )}
    >
      <div className='flex items-center gap-4 overflow-hidden'>
        <span className='grid place-items-center rounded-full bg-tertiary-background p-2.5'>
          <BellIcon className='text-brand-500' />
        </span>
        <h4 className='text-sm font-semibold first-letter:capitalize'>
          <Trans i18nKey={'home:youHaveNPendingCampaigns'}>
            You have <p className='inline-block text-brand-500'>{{ amount: data }}</p> pending campaign
          </Trans>
        </h4>
      </div>
      <div className='flex gap-2'>
        <Link to={RouteConstants.campaigns}>
          <Button text={t('home:goToCampaigns')} intent='secondary' size='md' className='border-brand-500 text-brand-500' />
        </Link>
        <CloseAlertButton onClick={toggleVisibility} disabled={!isOpen} />
      </div>
    </section>
  );
};
